<template>
  <Transition name="fade" mode="out-in">
    <component :is="currentComponent" :view="view" @done="nextPage" />
  </Transition>
</template>

<script setup lang="ts">
import { computed, shallowRef } from 'vue'

import type { QuestionnaireView } from '@/models/onboarding'
import type { BooksChoice } from '@/models/onboarding.types'

import BooksPick from '../BooksPick.vue'
import BooksDone from '../BooksDone.vue'

const props = defineProps<{
  view: QuestionnaireView
}>()

const currentComponent = shallowRef<typeof BooksPick | typeof BooksDone>(
  BooksPick,
)

const currentChoices = computed(() => {
  return props.view.currentChoice as BooksChoice
})

function nextPage(): void {
  const hasLikedBookes = currentChoices.value.some((book) => book.score > 0)

  if (hasLikedBookes) {
    currentComponent.value = BooksDone
    return
  }

  props.view.goNextPage()
}
</script>
